import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import Header from './Header';
import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';
import User from './User';
import UpdateEmail from './UpdateEmail';
import UpdateMobile from './UpdateMobile';
import AccountOptions from './AccountOptions';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import UberConnectModal from '../User/UberConnectModal';
import SideBarContent from '../SideBar/SideBarContent';
import SubmitImage from './SubmitImage';
import Loading from '../shared/Loading';
import './profile.css';

class NewProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deactivateAccount: false,
      loading: false
    };
  }
  componentDidMount() {
    this.props.retrieveProfile();
    this.props.loadData();
  }

  REOPEN_ACCOUNT = gql`
    mutation reopenUser {
      reopenUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  CLOSE_ACCOUNT = gql`
    mutation closeUser {
      closeUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  toggleClose = () => {
    this.setState({ loading: true });
    this.props.client
      .mutate({
        mutation:
          this.props.status === 'closed'
            ? this.REOPEN_ACCOUNT
            : this.CLOSE_ACCOUNT
      })
      .then(() => {
        this.props.loadData();
        window.location.reload();
      });
  };

  toggleDeactivateModal = () =>
    this.setState({ deactivateAccount: !this.state.deactivateAccount });

  modalContent = () => {
    const { status, total_cumulative_balance, operatingCity } = this.props;
    if (status === 'closed') {
      return 'Your request will be processed in 1-2 business days. We will contact you about next steps.';
    } else if (total_cumulative_balance < 0) {
      return `You currently have a negative balance of $${parseFloat(
        total_cumulative_balance
      ).toFixed(
        2
      )}. You must pay off your balance to close your Autzu account.`;
    } else if (operatingCity === 'toronto') {
      return 'Deactivating your Autzu account will prevent you from being able to book vehicles. If you are an operating driver, we will have your Uber account removed from the Autzu fleet within 1 business day. You can reactivate your account at any time!';
    } else {
      return 'Deactivating your Autzu account will prevent you from being able to book vehicles. You can reactivate your account at any time!';
    }
  };

  modalActionButton = () => {
    const { status, total_cumulative_balance, history } = this.props;
    let label = 'Deactivate';
    if (status === 'closed') {
      label = 'Reactivate';
    } else if (total_cumulative_balance < 0) {
      label = 'Pay';
    }

    return (
      <Button
        className="profile__deactivate-account--button"
        label={label}
        color={label === 'Pay' ? 'red' : '#128dff'}
        onClick={
          total_cumulative_balance < 0
            ? () => {
                history.push('/myearnings');
              }
            : () => {
                this.toggleClose();
                this.toggleDeactivateModal();
              }
        }
      />
    );
  };

  isMobile = () => {
    console.log(window.innerWidth);
    return window.innerWidth < 768;
  };

  profile = () => {
    const {
      profile_image,
      first_name,
      mobile,
      email,
      status,
      uber_token,
      account_name,
      uber_password,
      location,
      loadData,
      history,
      connected_uber_email,
      operatingCity,
      via_status,
      total_cumulative_balance
    } = this.props;
    const uberURL = `${
      process.env.REACT_APP_API_URL
    }/users/auth/uber?email=${encodeURIComponent(email)}`;
    // const api_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    const message = location.state ? location.state.res : null;

    return window.innerWidth < 768 ? (
      <Redirect to="/downloadapp" />
    ) : (
      <div className="profile">
        <Header
          persistentTitle
          title="My Profile"
          back
          onClick={() => {
            history.push('/dashboard');
          }}
        />
        {!uber_token &&
        operatingCity === 'toronto' &&
        (status === 'operating' || status === 'autzu_active') ? (
          <UberConnectModal
            uberURL={uberURL}
            username={account_name}
            password={uber_password}
            message={message}
          />
        ) : null}
        <SubmitImage type="uber_profile_image" refetch={loadData} />
        <Modal open={this.state.deactivateAccount}>
          <div className="profile__deactivate-account">
            {' '}
            <div className="profile__deactivate-account--text">
              {' '}
              {this.modalContent()}
            </div>
            <div className="profile__deactivate-account--actions">
              <Button
                className="profile__deactivate-account--button"
                label="Cancel"
                onClick={() => this.toggleDeactivateModal()}
                color="#414141"
              />{' '}
              {this.modalActionButton()}
            </div>
          </div>
        </Modal>
        <ScrollLock>
          <EncourageScroll className="profile__body container">
            <div className="profile__container">
              <div className="profile__sidebar">
                <SideBarContent status={status} signedIn />
              </div>
              <div className="profile__user--container">
                <User
                  status={status}
                  firstName={first_name}
                  profileImage={profile_image}
                />
                <div className="profile__info">
                  <div className="profile__info--title">
                    {' '}
                    Profile Information{' '}
                  </div>
                  <UpdateEmail email={email} />
                  <UpdateMobile
                    mobile={mobile || ''}
                    loadData={loadData}
                  />
                  <div className="profile__account-options">
                    <div className="profile__info--title">
                      {' '}
                      Account Options{' '}
                    </div>
                    <AccountOptions
                      status={status}
                      toggleDeactivateModal={this.toggleDeactivateModal}
                      uberURL={uberURL}
                      connectedUberEmail={connected_uber_email}
                      operatingCity={operatingCity}
                      viaStatus={via_status}
                    />
                  </div>
                </div>
              </div>
            </div>
          </EncourageScroll>
        </ScrollLock>
      </div>
    );
  };

  render() {
    const { loggedIn, status, location, sms_verfied } = this.props;
    const { state } = location;
    const { loading } = this.state;
    if (!loggedIn) {
      return <Redirect to="/login" />;
    } else if (sms_verfied) {
      return <Redirect to="/verify" />;
    } else if (loading) {
      return <Loading size="3x" />;
    } else if (status === 'lead' || status === 'subscribed') {
      return <Redirect to={{ pathname: '/apply', state: { ...state } }} />;
    }
    return this.profile();
  }
}

export default withApollo(withRouter(NewProfile));



// WEBPACK FOOTER //
// ./src/components/NewProfile/index.js